import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger.js';
gsap.registerPlugin(ScrollTrigger);
import { DrawSVGPlugin } from './DrawSVGPlugin.js';
import SplitType from "split-type";
gsap.registerPlugin(DrawSVGPlugin);

window.addEventListener('DOMContentLoaded', () => {
    selfFadeEffect('.js-fade__in');
    childrenFadeEffect('.js-fade__children');
    selfFadeEffectDelayed('.js-fade__in-delayed', 0.5);
    childrenFadeEffectDelayed('.js-fade__children-delayed', 0.5);

    // goToSection('details');
    // letterAnim('.property-management__content strong');
});

let selfFadeEffect = (target) => {
    // fade in animation for each defined element
    const fadeIn = document.querySelectorAll(target);
    if (fadeIn.length) {
        fadeIn.forEach((el) => {
            const fadeTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            fadeTl.fromTo(el, { yPercent: 5, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1, ease: 'ease' });
        });
    }
};

let childrenFadeEffect = (target) => {
    // fade in animation for defined element's children
    const fadeChildren = document.querySelectorAll(target);
    if (fadeChildren.length) {
        fadeChildren.forEach((el) => {
            const showTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            showTl.fromTo(el.children, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 1, stagger: 0.5, ease: 'ease' });
        });
    }
};

let selfFadeEffectDelayed = (target, delay) => {
    // fade in animation for each defined element
    const fadeIn = document.querySelectorAll(target);
    if (fadeIn.length) {
        fadeIn.forEach((el) => {
            const fadeTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            fadeTl.fromTo(el, { yPercent: 5, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1, delay: delay, ease: 'ease' });
        });
    }
};

let childrenFadeEffectDelayed = (target, delay) => {
    // fade in animation for defined element's children
    const fadeChildren = document.querySelectorAll(target);
    if (fadeChildren.length) {
        fadeChildren.forEach((el) => {
            const showTl = gsap.timeline({
                scrollTrigger: {
                    trigger: el,
                    start: 'top 90%',
                },
            });
            showTl.fromTo(el.children, { y: 20, opacity: 0 }, { y: 0, opacity: 1, duration: 1, delay: delay, stagger: 0.5, ease: 'ease' });
        });
    }
};

function goToSection(element) {
    ScrollTrigger.create({
        trigger: '#' + element,
        start: 'top 40%',
        end: 'bottom 40%',
        markers: false,
        scrub: false,
        // invalidateOnRefresh: true,
        onEnter: function () {
            jQuery('.property__nav--item').removeClass('active');
            jQuery('.' + element).addClass('active');
        },
        onEnterBack: function () {
            jQuery('.property__nav--item').removeClass('active');
            jQuery('.' + element).addClass('active');
        },
    });
}

// LETTER ANIMATION
let letterAnim = (el) => {
    let letterTlFrom, letterTlTo;
    const targets = document.querySelectorAll(el);

    letterTlFrom = {};
    letterTlTo = {
        textShadow: '-1px -1px 0 transparent, 1px -1px 0 transparent, -1px 1px 0 transparent, 1px 1px 0 transparent',
        color: '#4B92C1',
    };

    letterTlTo.duration = 0.5;
    letterTlTo.stagger = 0.05;
    letterTlTo.ease = 'none';

    if (targets.length) {
        targets.forEach((target, i) => {
            let letterTl = [];
            letterTl[i] = gsap.timeline({
                scrollTrigger: {
                    trigger: target,
                    // markers: true,
                    start: 'top 75%',
                    // start: 'top 60%',
                    end: '+=10%',
                    // scrub: 1,
                },
            });
            letterTl[i].fromTo(target.children, letterTlFrom, letterTlTo);
        });
    }
};

// Product Page Hero Image Animation
window.addEventListener('DOMContentLoaded', () => {
    if(document.body.classList.contains('page-template-all-products')){
        // const heroImageProductsTriggerEl = document.querySelector('.products__image')
        const heroImageProductsCover = document.querySelector('.product-image-cover')
        setTimeout(function(){
            const heroImageProductTL = gsap.timeline({
                // scrollTrigger:{
                //     trigger: heroImageProductsTriggerEl,
                //     // markers: true,
                //     start: 'top 5%',
                // }
            })
            heroImageProductTL.fromTo(heroImageProductsCover, {top: 0},{top: '100%', duration: 1})
        },500)

    }
})

//Single product page images animation
window.addEventListener('DOMContentLoaded', () => {
    if(document.body.classList.contains('single-product')){
        const Images = document.querySelectorAll('.single-product-image')
        // const ImagesCover = document.querySelectorAll('.single-product-image-cover')

        Images.forEach(x => {

            const singleProudctImagesTL = gsap.timeline({
                scrollTrigger:{
                    trigger: x,
                    // markers: true,
                    start: 'top 70%',
                }
            })
            // singleProudctImagesTL.fromTo(x.childNodes[3], {top: 0},{top: '100%', duration: 0.9})
            singleProudctImagesTL.from(x, {opacity: 0, bottom: -350, duration: 1.7, ease: "expo.out"})
            // singleProudctImagesTL.timeScale(2)
        })



    }
})
let sectionImageUpper = document.querySelector('.section__image__upper');
let sectionImageBottom= document.querySelector('.section__image__bottom');

if (sectionImageUpper && sectionImageBottom) {
    let parallaxImages = gsap.timeline({
        scrollTrigger: {
            trigger: '#home-section-2',
            start: '-40%',
            end: '140%',
            scrub: 1
        }
    });
    parallaxImages.to(sectionImageUpper, {y: '10%', ease: 'ease', duration: 2.5}, "<")
        .to(sectionImageBottom, {y: '-40%', ease: 'ease', duration: 2.5}, "<")
}

let partnersRight = document.querySelector('.partners__right');
let partnersLeft = document.querySelector('.partners__left');
if (partnersRight && partnersLeft) {
    let marquee = gsap.timeline({
        scrollTrigger: {
            trigger: '#home-section-4',
            start: '-50%',
            end: '55%',
            scrub: 1
        }
    });
    marquee
        .to('.partners__right', {x: '-10%', ease: 'ease'}, "<")
        .to('.partners__left', {x: '10%', ease: 'ease'}, "<")
}


// Button animation
let text = new SplitType('.btn__animation span')

const btnAnimation = document.querySelectorAll('.btn__animation')

window.addEventListener('DOMContentLoaded', () => {
    let screenWidth = document.body.clientWidth

    if(screenWidth > 767){
        if(btnAnimation.length > 0){
            btnAnimation.forEach(btn => {

                let buttonCharsOld = btn.children[0].querySelectorAll('.char')
                let buttonCharsNew = btn.children[1].querySelectorAll('.char')
                let timeline = gsap.timeline({
                    paused: true
                })

                timeline.fromTo(buttonCharsOld,{ opacity: 1}, { opacity: 0, y: -10, stagger: 0.01})
                timeline.fromTo(buttonCharsNew, { opacity: 0, y: 20},{ opacity: 1, y: 0, stagger: 0.01}, '<')


                btn.addEventListener("mouseenter", function(){
                    timeline.restart()
                })
                btn.addEventListener("mouseleave", function(e){
                    timeline.paused()
                })
            })
        }
    }
});
